import { render, staticRenderFns } from "./caseShow.vue?vue&type=template&id=4d34a4fd&scoped=true&"
import script from "./caseShow.vue?vue&type=script&lang=js&"
export * from "./caseShow.vue?vue&type=script&lang=js&"
import style0 from "./caseShow.vue?vue&type=style&index=0&id=4d34a4fd&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4d34a4fd",
  null
  
)

export default component.exports